import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { jamaahApi, JAMAAH_TOKEN_KEY } from "@/lib/jamaahApi";

const JamaahContext = createContext(null);

export function JamaahProvider({ children }) {
  const [jamaah, setJamaah] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(JAMAAH_TOKEN_KEY)) return setJamaah(false);
    jamaahApi
      .get("/jamaah/me")
      .then(({ data }) => setJamaah(data))
      .catch(() => {
        localStorage.removeItem(JAMAAH_TOKEN_KEY);
        setJamaah(false);
      });
  }, []);

  const applyAuth = (data) => {
    localStorage.setItem(JAMAAH_TOKEN_KEY, data.token);
    setJamaah(data.jamaah);
    return data.jamaah;
  };

  const register = useCallback(async (payload) => applyAuth((await jamaahApi.post("/jamaah/auth/register", payload)).data), []);
  const login = useCallback(async (phone, password) => applyAuth((await jamaahApi.post("/jamaah/auth/login", { phone, password })).data), []);
  const logout = useCallback(() => {
    localStorage.removeItem(JAMAAH_TOKEN_KEY);
    setJamaah(false);
  }, []);

  return <JamaahContext.Provider value={{ jamaah, setJamaah, register, login, logout }}>{children}</JamaahContext.Provider>;
}

export const useJamaah = () => useContext(JamaahContext);
